import dayjs from "../../../../utils/dateTime";

// Status values from the API are lowercase
export const LEAVE_STATUS = {
  pending: { label: "Pending", tone: "amber" },
  approved: { label: "Approved", tone: "green" },
  rejected: { label: "Rejected", tone: "red" },
  cancelled: { label: "Cancelled", tone: "gray" },
};

// An employee's cancel (pending or approved leave) or edit (approved leave),
// waiting for an approver. Check this before the status.
const CHANGE_LABEL = { CANCEL: "Cancel request", EDIT: "Edit request" };
export const changeLabel = (change) => CHANGE_LABEL[change] || "";

/** Waiting for a decision: a new request, or a cancel / edit request. */
export const isAwaitingDecision = (request) =>
  request?.status === "pending" || !!request?.pendingChange;

const parse = (ymd) => dayjs(ymd, "YYYY-MM-DD", true);

/**
 * Plain leave dates → "Oct 20, 2026", "Oct 20 – 22, 2026", "Oct 30 – Nov 2, 2026"
 * or "Dec 30, 2026 – Jan 2, 2027". Never goes through new Date().
 */
export const formatLeaveDates = (start, end) => {
  if (!start) return "—";
  const s = parse(start);
  const e = parse(end || start);
  if (!s.isValid() || !e.isValid()) return `${start} – ${end}`;
  if (s.isSame(e, "day")) return s.format("MMM D, YYYY");
  if (s.year() !== e.year())
    return `${s.format("MMM D, YYYY")} – ${e.format("MMM D, YYYY")}`;
  if (s.month() !== e.month())
    return `${s.format("MMM D")} – ${e.format("MMM D, YYYY")}`;
  return `${s.format("MMM D")} – ${e.format("D, YYYY")}`;
};

/** 1 → "1 day", 1.5 → "1.5 days" */
export const formatDays = (n) => {
  const v = Number(n) || 0;
  return `${v} ${v === 1 ? "day" : "days"}`;
};

/** Calendar days from start to end, both included (plain dates). */
export const daysInclusive = (start, end) => {
  const s = parse(start);
  const e = parse(end);
  if (!s.isValid() || !e.isValid() || e.isBefore(s)) return 0;
  return e.diff(s, "day") + 1;
};

/** Balance amounts can arrive as strings (balances overview endpoint). */
export const num = (v) => {
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
};
